import { render, staticRenderFns } from "./RecommendedLang.vue?vue&type=template&id=6c181845&scoped=true&"
import script from "./RecommendedLang.vue?vue&type=script&lang=js&"
export * from "./RecommendedLang.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedLang.vue?vue&type=style&index=0&id=6c181845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c181845",
  null
  
)

export default component.exports